/* eslint-disable no-restricted-globals */
/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable no-alert */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-console */

import axios from 'axios';
import { API_BASE_URL } from '../../config';
import { errorMessage, successMessage } from './message';

const api = {
  deariEnv: 'dev',

  async mainLoad() {
    try {
      const res = await axios.get(`${API_BASE_URL}/common/rally`, {
        params: { rallyType: 'C' },
      });
      return res.data.data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  },

  // 조선닷컴 회원 체크
  async memberCheck(seq, name, password) {
    try {
      await axios.post(`${API_BASE_URL}/common/arc/profile`, {
        rally_seq: seq,
        userName: name,
        credentials: password,
      });
      return true;
    } catch (err) {
      console.log(err);
      return false;
    }
  },

  // 무료 코드 사용
  async freeCheck(value) {
    try {
      const res = await axios.get(`${API_BASE_URL}/common/check/free-code`, {
        params: { freeCode: value },
        validateStatus(status) {
          return status === 200;
        },
      });
      if (res.data.status && res.data.status === 404) {
        return false;
      }

      return true;
    } catch (err) {
      console.error('freeCheck error:', err);
      return false;
    }
  },

  // 참가신청 중복체크
  async duplicateMemberCheck(seq, name, birth, email) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
        email,
      });
      const { duplicateYn } = res.data.data;

      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      else alert(err.response.data.data);
      return false;
    }
  },

  // URL 추가 신청 중복 체크
  async duplicateMemberCheckAdd(seq, name, birth, email, type) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/add/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
        email,
        receiveType: type,
      });
      const { duplicateYn } = res.data.data;
      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      else alert(err.response.data.data);
      return false;
    }
  },

  // 멤버십 추첨 중복 체크
  async duplicateMemberCheckPick(seq, name, birth) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/membership/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
      });
      const { duplicateYn } = res.data.data;
      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return res;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      else (alert(err.response.data.data));
      return false;
    }
  },

  // 풀코스 5~8회 체크
  async duplicateMemberCheckSubHof(seq, name, birth, email, type, pTel) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/full/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
        email,
        receiveType: type,
        pTel,
      });
      const { duplicateYn } = res.data.data;
      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      else alert(err.response.data.data);
      return false;
    }
  },

  // 명예의전당 헌액 예정자 체크
  async duplicateMemberCheckHof(seq, name, birth, email, type, pTel) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/hof/duplicate/member`, {
        rallySeq: seq,
        name,
        birth,
        email,
        receiveType: type,
        pTel,
      });
      const { duplicateYn } = res.data.data;
      if (!duplicateYn) {
        alert(errorMessage.auth.duplicate);
        return false;
      }
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      else alert(err.response.data.data);
      return false;
    }
  },

  // 춘천마라톤 일반신청
  async applyMember(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/chuncheon/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      else alert(err.response.data.data);
      return false;
    }
  },

  // 멤버십 얼리버드
  async earlyMember(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/chuncheon/earlybird/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) {
        alert(errorMessage.server);
      } else {
        alert(err.response.data.data);
      }
      return false;
    }
  },

  // 추가모집 신청
  async applyMemberAdd(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/chuncheon/add/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 400) alert(errorMessage.apply.finish.course);
      return false;
    }
  },

  // 명예의전당 헌액 예정자 신청
  async applyMemberHof(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/chuncheon/hof/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 400) alert(errorMessage.apply.finish.course);
      return false;
    }
  },

  // 풀코스 5~8회 추첨 신청(쿠폰)
  async applyMemberSubHof(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/chuncheon/full/apply/member`, jsonData);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 400) alert(errorMessage.apply.finish.course);
      return false;
    }
  },

  // 참가신청 조회
  async infoMember(seq, name, birth, password) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/apply/member/info`, {
        rallySeq: seq,
        name,
        birth,
        password,
      });
      return res;
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 404) alert(errorMessage.confirm.empty);
      if (err.response?.status === 400) alert(errorMessage.confirm.fix);
      return false;
    }
  },

  // 독자인증 체크
  async checkSubscription(jsonData) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/check/subscription`, jsonData);
      if (res.data.data.subsYn === 'N') {
        alert(errorMessage.auth.email.error);
        return false;
      // eslint-disable-next-line no-else-return
      } else {
        alert(successMessage.auth.auth);
        return res.data;
      }
    } catch (err) {
      console.log(err);
      if (err.response?.status === 500) alert(errorMessage.server);
      if (err.response?.status === 409) alert(errorMessage.auth.email.subsDuplicate);
      if (err.response?.status === 404) alert(errorMessage.auth.impossible);
      return false;
    }
  },

  // 비밀번호 찾기
  async searchPasswordApi(seq, name, birth) {
    try {
      await axios.post(`${`${API_BASE_URL}/common/find-password`}`, {
        rallySeq: seq,
        name,
        birth,
      });
      alert(successMessage.password);
      return true;
    } catch (err) {
      console.log(err);

      if (err.status === 500) {
        alert(errorMessage.server);
      } else {
        alert(err.response.data.data);
      }

      return false;
    }
  },

  // 개인 정보 수정
  async changepartInfo(jsonData) {
    try {
      await axios.post(`${API_BASE_URL}/common/modify/member`, jsonData);
      alert(successMessage.confirm);
      location.href = '../index.html';
      return true;
    } catch (err) {
      console.log(err);
      if (err.status === 500) {
        alert(errorMessage.server);
      } else {
        alert(err.response.data.data);
      }
      return false;
    }
  },

  // 페이스메이커 신청 api 호출
  async partFacemaker(jsonData) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/apply/pace-maker`, jsonData);

      return res.data;
    } catch (err) {
      console.log(err);
      if (err.status === 500) { alert('Server Error'); }
      if (err.status === 409) { alert('이미 신청한 이력이 있습니다.'); }

      return false;
    }
  },

  // 대회 기록(개인별)
  async indRecord(name, birth) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/record/current`, {
        type: 'personal',
        year: '2025',
        name,
        birth,
      });
      return res.data;
    } catch (err) {
      console.log(err);

      if (err.status === 500) { alert(errorMessage.server); }
      if (err.status === 404) { alert(errorMessage.record.empty); }

      return false;
    }
  },

  // 대회 기록(부문별)
  async partIndRecord(code, gender, age, number) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/record/current`, {
        type: 'year',
        code,
        year: '2025',
        gender,
        age,
        page: number,
      });
      return res.data;
    } catch (err) {
      console.log(err);

      if (err.status === 500) { alert(errorMessage.server); }
      if (err.status === 404) { alert(errorMessage.record.empty); }

      return false;
    }
  },

  // 역대 기록(개인별)
  async allTimeRecord(name, birth) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/record/history`, {
        type: 'personal',
        name,
        birth,
      });
      return res.data;
    } catch (err) {
      console.log(err);

      if (err.status === 500) { alert(errorMessage.server); }
      if (err.status === 404) { alert(errorMessage.record.empty); }

      return false;
    }
  },

  // 역대 기록(부문별)
  async partTimeRecord(inputArr) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/record/history`, {
        type: 'year',
        code: inputArr[0],
        year: inputArr[1],
        gender: inputArr[2],
        age: inputArr[3],
        page: inputArr[4],
      });
      return res.data;
    } catch (err) {
      console.log(err);

      if (err.status === 500) { alert(errorMessage.server); }
      if (err.status === 404) { alert(errorMessage.record.empty); }

      return false;
    }
  },

  // 명예의전당
  async hofList(inputArr) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/hof/list`, {
        gender: inputArr[0],
        recordCnt: inputArr[1],
        bestRecord: inputArr[2],
        type: inputArr[3],
        value: inputArr[4],
        page: inputArr[5],
      });

      return res.data;
    } catch (err) {
      if (err.status === 500) { alert('Server Error'); }
      if (err.status === 404) { alert('조회 결과가 없습니다.'); }
      return false;
    }
  },

  async hofListIndividual(value) {
    try {
      const res = await axios.post(`${API_BASE_URL}/chuncheon/hof/detail`, {
        no: value,
      });

      return res.data;
    } catch (err) {
      console.log(err);
      if (err.status === 500) { alert('Server Error'); }
      if (err.status === 404) { alert('조회 결과가 없습니다.'); }
      return false;
    }
  },

  // 일반 신청 결제 정보 저장(web)
  async setSaveOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/save/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return false;
    }
  },

  // 얼리버드 신청 결제 정보 저장(web)
  async setEarlyOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/earlybird/save/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return 'error';
    }
  },

  // 버스 결제 정보 저장(web)
  async setSaveBusOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/save/new-bus-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(err.response.data.data);
      return false;
    }
  },

  // URL추가신청 결제 정보 저장(web)
  async setSaveOrderAdd(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/add/save/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(err.response.data.data);
      return false;
    }
  },

    // URL추가신청 결제 정보 저장(web)
    async setSaveOrderHof(jsonObject) {
      try {
        const res = await axios.post(`${API_BASE_URL}/common/hof/save/new-order`, jsonObject);
        return res.data.data;
      } catch (err) {
        if (err.response.data.status === 400) {
          alert(err.response.data.data);
        } else {
          alert('Server Error');
        }
        return false;
      }
    },

      // URL추가신청 결제 정보 저장(web)
  async setSaveOrderSubHof(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/full/save/new-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      if (err.response.data.status === 400) {
        alert(err.response.data.data);
      } else {
        alert('Server Error');
      }
      return false;
    }
  },

  // 결제창 호출
  async setWebOrder(oid) {
    await axios.get(`${API_BASE_URL}/common/request/order-form`, { params: { oid } })
    .then((resolve) => {
      const { data: info } = resolve;
      const { status, data } = info;
      if (status === 200) {
        const existingForm = document.querySelector('#payForm');
        if (existingForm) {
          existingForm.remove();
        }

        const form = document.createElement('form');
        form.method = 'post';
        form.acceptCharset = 'UTF-8';
        form.hidden = true;
        form.id = 'payForm';

        Object.entries(data).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        document.querySelector('#payment-page').appendChild(form);
        INIStdPay.pay('payForm');
      } else {
        alert('요청 실패');
      }
    });
  },

  // 버스 결제창 호출
  async setWebBusOrder(oid) {
    await axios.get(`${API_BASE_URL}/common/request/bus-order-form`, { params: { oid } })
    .then((resolve) => {
      const { data: info } = resolve;
      const { status, data } = info;
      if (status === 200) {
        const existingForm = document.querySelector('#payForm');
        if (existingForm) {
          existingForm.remove();
        }

        const form = document.createElement('form');
        form.method = 'post';
        form.acceptCharset = 'UTF-8';
        form.hidden = true;
        form.id = 'payForm';

        Object.entries(data).forEach(([key, value]) => {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        });

        document.querySelector('#payment-page').appendChild(form);
        INIStdPay.pay('payForm');
      } else {
        alert('요청 실패');
      }
    });
  },

  // 참가 취소
  async setApplyCancel(jsonObject) {
    try {
      await axios.post(`${API_BASE_URL}/common/cancel/member`, jsonObject);
      alert('환불 및 참가 신청이 취소되었습니다.');
      location.href = '../index.html';
      return true;
    } catch (err) {
      alert(err.data.data.message);

      document.getElementById('refund_btn').disabled = false;
      return false;
    }
  },

  // 버스 취소
  async setBusCancel(jsonObject) {
    try {
      await axios.post(`${API_BASE_URL}/common/cancel/bus`, jsonObject);
      alert('환불 및 버스 예약이 취소되었습니다.');
      location.href = '../index.html';
      return true;
    } catch (err) {
      console.log(err);
      alert(err.data.data.message);

      return false;
    }
  },

  // 모바일 결제 창 호출
  async mobileOrder() {
    let oid = '';
    oid = await saveMobileOrder();
    if (oid !== 'error') {
      $('#payment_popup').prop('href', `${url}/common/mobile-open?oid=${oid}`);
      document.getElementById('payment_popup').click();
      // window.open(url + "/mobile-open?oid=" + oid, "결제창");
      }
      // window.open(url + "/mobile-open?oid=" + oid, "결제창");
  },

  // 일반 신청 결제 정보 저장(mobile)
  async setSaveMobileOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/save/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  // 얼리버드 신청 결제 정보 저장(mobile)
  async setEarlyMobileOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/earlybird/save/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  // 버스 결제 정보 저장(mobile)
  async setSaveMobileBusOrder(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/save/new-bus-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  // URL추가신청 결제 정보 저장(mobile)
  async setSaveMobileOrderAdd(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/add/save/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

    // URL추가신청 결제 정보 저장(mobile)
    async setSaveMobileOrderHof(jsonObject) {
      try {
        const res = await axios.post(`${API_BASE_URL}/common/hof/save/new-mobile-order`, jsonObject);
        return res.data.data;
      } catch (err) {
        alert(error.response.data.data);
        return false;
      }
    },

      // URL추가신청 결제 정보 저장(mobile)
  async setSaveMobileOrderSubHof(jsonObject) {
    try {
      const res = await axios.post(`${API_BASE_URL}/common/full/save/new-mobile-order`, jsonObject);
      return res.data.data;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },

  async getPointData(uuid) {
    const baseUrl = 'www.chuncheonmarathon.com';
    const hostUrl = window.location.hostname === baseUrl ? 'membership' : 'membership-dev';

    try {
      const res = await axios.post(`https://api-gateway.chosun.com/${hostUrl}/point/v1/check-point/${uuid}`);
      return res;
    } catch (err) {
      alert(error.response.data.data);
      return false;
    }
  },
};

export default api;
